// extracted by mini-css-extract-plugin
export default {"list":"bOrw7aysHOckCt3kOTk30w==","bottomSection":"gLywxuJH6KhHj4hQewJg0g=="};